import type {InterfaceStrings} from './strings'

export const ru: InterfaceStrings = {
    nav: {
        beginSession: 'Начать',
        faq: 'Вопросы',
        pricing: 'Цены',
        legal: 'Правовая информация',
        signIn: 'Войти',
        viewPricing: 'Посмотреть цены',
        signOut: 'Выйти',
        account: 'Аккаунт',
        menu: 'Меню',
        closeMenu: 'Закрыть меню',
        mainNav: 'Основная навигация',
        sessions: {one: '{n} сеанс', few: '{n} сеанса', many: '{n} сеансов', other: '{n} сеанса'},
    },
    footer: {
        selfHypnosisFor: 'Самогипноз при',
        anxiety: 'Тревоге',
        sleep: 'Бессоннице',
        stress: 'Стрессе',
        confidence: 'Неуверенности',
        focus: 'Рассеянности',
        learn: 'О методе',
        ericksonian: 'Что такое эриксоновский гипноз',
        aiHow: 'Как работает гипноз с ИИ',
        vsMeditation: 'Гипноз или медитация',
        methods: 'Практики',
        languages: 'Языки',
    },
    page: {
        cta: 'Начать бесплатный сеанс',
        hint: 'Первый сеанс бесплатный',
        exploreFurther: 'Читать дальше',
        disclaimer:
            'Quies — инструмент для расслабления и самопознания. Это не медицинское изделие: он не диагностирует, не лечит и не излечивает никаких заболеваний. Если вы переживаете психологический кризис, обратитесь к специалисту.',
        transcript: 'Текст',
        transcriptNote: 'Отрывок из настоящего сеанса Quies — так, как он прозвучал.',
        breadcrumb: 'Навигационная цепочка',
    },
    pricing: {
        selectPlan: 'Выбрать пакет',
        subscribe: 'Оформить подписку',
        perMonth: 'в месяц',
        manageSubscription: 'Управление подпиской',
        replayFree: 'Повторное прослушивание прошедшего сеанса всегда бесплатно.',
        offerLead: 'Каждый сеанс начинается там, где закончился предыдущий.',
    },
    session: {
        chooseLanguage: 'Выберите язык',
        changeLanguage: 'Сменить язык',
        changeVoice: 'Сменить голос',
        previewVoice: 'Послушать голос: {voice}',
        stopPreview: 'Остановить пробу',
        continue: 'Продолжить',
        composing: 'Quies пишет ваш сеанс',
        preparing: 'Ваша медитация готовится',
        pickingUp: 'продолжаем с того места, где вы остановились',
        today: 'Сегодня',
        yesterday: 'Вчера',
        loading: 'Загрузка…',
        showEarlier: 'Показать предыдущие ({count})',
        tryDifferentApproach: 'Попробовать другой путь',
        nothingAdded: 'Без добавлений',
        purchaseConfirmed: 'Покупка подтверждена',
        firstSessionNote: 'Ваш первый сеанс бесплатный. Перед тем как слушать, нужно будет войти.',
    },
    threshold: {
        title: 'Войдите, чтобы слушать',
        message: 'Ваш первый сеанс бесплатный. Банковская карта не нужна.',
        google: 'Продолжить через Google',
        sendLink: 'Отправить мне ссылку для входа',
        sending: 'Отправляем…',
        emailLabel: 'Адрес электронной почты',
        or: 'или',
        waitingTitle: 'Проверьте почту',
        waitingBody: 'Мы отправили ссылку для входа на {email}.',
        sendAgain: 'Отправить ещё раз',
        googleInstead: 'Лучше войти через Google',
        codeLabel: 'Или введите 6-значный код из письма',
        codeSubmit: 'Продолжить',
        codeSubmitting: 'Проверяем…',
        codeWrong: 'Этот код неверный.',
        codeDead: 'Этот код больше не действует. Воспользуйтесь ссылкой из письма или запросите новое.',
        errors: {
            invalidEmail: 'Введите действующий адрес электронной почты.',
            rateLimited: 'Слишком много попыток. Повторите через несколько минут.',
            sessionError: 'С Вашим входом что-то пошло не так. Обновите страницу и повторите попытку.',
            sendFailed: 'Не удалось отправить письмо. Повторите попытку.',
            sessionExpired: 'Время входа истекло. Обновите страницу и повторите попытку.',
            generic: 'Что-то пошло не так. Повторите попытку.',
        },
    },
    player: {
        play: 'Воспроизвести',
        pause: 'Пауза',
        playAgain: 'Прослушать снова',
        seek: 'Позиция',
        eyesClosed: 'Глаза закрыты',
        openEyes: 'Открыть глаза',
        paused: 'На паузе',
        unavailable: 'Аудио недоступно',
        untitled: 'Сеанс Quies',
    },
    failure: {
        turnFailed: 'У нас что-то пошло не так. Ваш ответ сохранён.',
        reconnecting: 'Переподключение…',
        refusalTitle: 'Пойдём другим путём',
        refusal: 'На часть вашего сообщения не удалось ответить. Сформулируйте иначе или отправьте ещё раз.',
        openElsewhere: 'Этот сеанс открыт и в другом окне.',
        serviceDown: 'Quies сейчас недоступен. Ничего из сделанного вами не потеряно.',
        sessionsUsedTitle: 'Ваши сеансы использованы',
        voiceFailedTitle: 'Ваша медитация написана',
        voiceFailed: 'Озвучить её сейчас не удалось. Ничего не потеряно, а повторная озвучка ничего не стоит.',
        voiceStopped: 'Голос прервался на середине. Он может продолжить с того места, где остановился.',
        streamMissing: 'Ваша медитация готова, но до этой страницы она не дошла.',
        tapToListen: 'Нажмите, чтобы слушать',
        fileFailed: 'Эту запись не удаётся воспроизвести. Медитацию можно озвучить заново бесплатно.',
        recordingGone: 'Эта запись больше не хранится.',
        purchaseCancelled: 'Покупка отменена. Деньги не списаны.',
        purchasePending: 'Ваш платёж подтверждён. Сеансы поступают дольше обычного.',
        checkoutFailed: 'Не удалось завершить оплату. Деньги не списаны.',
        sessionEnded: 'Этот сеанс подошёл к концу.',
        busy: 'Quies сейчас очень загружен. Ваш ответ сохранён; попробуйте ещё раз через минуту.',
        tooLong: 'Этот сеанс стал длиннее, чем Quies может вместить. Он возвращён вам.',
        notSaved: 'Этот шаг не удалось сохранить. Попробуйте ещё раз, чтобы продолжить с этого места.',
        meditationRefused:
            'Эту медитацию не удалось написать так, как вы просили. Сформулируйте иначе или начните заново: этот сеанс будет вам возвращён.',
        meditationRefusedUncharged:
            'Эту медитацию не удалось написать так, как вы просили. Сформулируйте иначе или начните заново.',
        linkExpired: 'Срок действия ссылки для входа истёк. Запросите новую.',
        oauthFailed: 'Вход был прерван. Попробуйте ещё раз.',
        offline: 'Нет подключения к сети. Ваш ответ отправится, как только связь вернётся.',
        voiceChanged: 'Ваш голос больше недоступен; эту медитацию прочитает другой голос.',
        voiceReturned: 'Озвучить по-прежнему не удалось. Этот сеанс возвращён вам.',
        voiceFailedAgain: 'Озвучить по-прежнему не удалось.',
        voiceResuming: 'Голос возвращается…',
        voiceLimited: 'За этот час для вас уже озвучено несколько медитаций. Попробуйте чуть позже.',
        tryAgain: 'Попробовать снова',
        rephrase: 'Сформулировать иначе',
        resume: 'Возобновить',
        voiceAgain: 'Озвучить заново',
        listen: 'Слушать',
        continue: 'Продолжить',
        begin: 'Начать сеанс',
        signIn: 'Войти',
        checkAgain: 'Проверить снова',
        sendLink: 'Отправить ссылку для входа',
        useEmail: 'Войти по электронной почте',
    },
}
